export default {"src":"/_next/static/media/share-forward-fill.e14ca3a1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};